import { styled } from '@styledComponents';
import { Flex } from '@components/Flex';
import { Column } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { themeSpace, themeColor, themeMediaQuery } from '@utils/styledTheme.util';

export const SectionWrapper = styled(Flex)<{ background: string; backgroundMobile: string }>`
  height: 54vw;
  background-size: cover;
  background-image: ${props => `url(${props.background})`};
  ${themeMediaQuery('below_sm')} {
    height: 84vh;
    min-height: 750px;
    justify-content: center;
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
    background-image: ${props => `url(${props.backgroundMobile})`}, linear-gradient(0deg, ${themeColor('black')} 50%, transparent);
  }
  @media (min-width: 36rem) and (max-width: 52.063rem) {
    height: 100vh;
  }
`;

export const ContentColumn = styled(Column)`
  display: flex;
  justify-content: flex-start;
`;

export const LottieContainer = styled(Flex)`
  min-height: 100%;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    margin-bottom: ${themeSpace(6)};
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 74px;
  ${themeMediaQuery('sm')} {
    width: 152px;
  }
`;
